import * as modern from './templates/modern';
import * as classic from './templates/classic';
import * as minimal from './templates/minimal';
import { Document } from 'docx';
import {
  ResumeDocument,
  ResumeFontFamilyId,
  ResumePersonalization,
  TemplateId,
} from '../../types';

export interface TemplateLabels {
  contact: string;
  summary: string;
  experience: string;
  education: string;
  skills: string;
  languages: string;
  links: string;
  present: string;
}

export interface TemplateRenderer {
  toHtml: (
    r: ResumeDocument,
    labels: TemplateLabels,
    personalization: ResumePersonalization
  ) => string;
  toDocx: (
    r: ResumeDocument,
    labels: TemplateLabels,
    personalization: ResumePersonalization
  ) => Document;
}

export const templateRegistry: Record<TemplateId, TemplateRenderer> = {
  modern,
  classic,
  minimal,
};

export const templateIds: TemplateId[] = ['modern', 'classic', 'minimal'];

export const fontFamilyIds: ResumeFontFamilyId[] = [
  'sans',
  'serif',
  'modern',
  'mono',
];

export const FONT_SCALE_MIN = 0.5;
export const FONT_SCALE_MAX = 2.0;
export const FONT_SCALE_STEP = 0.1;

export default {};
